export const reviews = {
  reviewList: {
    numberOfReviews: '{{ count }} отзывов',
  },

  reviewStats: {
    reviewAmount: {
      '=0': 'нет оценок',
      one: '# оценка',
      few: '# оценки',
      many: '# оценок',
      other: '# оценок',
    },
    reviewAmountR: {
      '=0': 'нет оценок',
      one: ' # оценки',
      few: ' # оценкок',
      many: ' # оценок',
    },
  },
};
